import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';
import { HONDA_THEME_NAME } from '../../utils/constants';

const themeStyles = new ThemeStyles();

themeStyles.addThemeStyles(
  'ModelPageNavContainer',
  HONDA_THEME_NAME,
)(({ top }) =>
  css({
    top,
  }),
);

export default themeStyles;
